document.documentElement.classList.remove('no-js');

const qs=(s,c=document)=>c.querySelector(s);
const qsa=(s,c=document)=>[...c.querySelectorAll(s)];

const header=qs('[data-site-header]');
window.addEventListener('scroll',()=>header?.classList.toggle('is-scrolled',window.scrollY>30));

const glow=qs('[data-cursor-glow]');
window.addEventListener('mousemove',e=>{if(glow){glow.style.left=e.clientX+'px';glow.style.top=e.clientY+'px';}});

const revealObserver=new IntersectionObserver(entries=>{
  entries.forEach(entry=>{if(entry.isIntersecting)entry.target.classList.add('is-visible');});
},{threshold:.12});
qsa('.cz-reveal').forEach(el=>revealObserver.observe(el));

const drawer=qs('[data-cart-drawer]');
const overlay=qs('[data-cart-overlay]');
const cartItems=qs('[data-cart-items]');
const cartCount=qs('[data-cart-count]');
const cartTotal=qs('[data-cart-total]');

function money(cents){
  return new Intl.NumberFormat(document.documentElement.lang || 'en-IN',{
    style:'currency',currency:(window.Shopify?.currency?.active || 'INR')
  }).format(cents/100);
}
function openCart(){
  drawer?.classList.add('is-open');
  overlay?.classList.add('is-visible');
  drawer?.setAttribute('aria-hidden','false');
}
function closeCart(){
  drawer?.classList.remove('is-open');
  overlay?.classList.remove('is-visible');
  drawer?.setAttribute('aria-hidden','true');
}
qsa('[data-cart-open]').forEach(b=>b.addEventListener('click',openCart));
qsa('[data-cart-close]').forEach(b=>b.addEventListener('click',closeCart));
overlay?.addEventListener('click',closeCart);

async function getCart(){
  const r=await fetch(window.Shopify.routes.root+'cart.js');
  return await r.json();
}
async function renderCart(){
  const cart=await getCart();
  if(cartCount) cartCount.textContent=cart.item_count;
  if(cartTotal) cartTotal.textContent=money(cart.total_price);
  if(!cartItems) return;
  if(!cart.items.length){
    cartItems.innerHTML='<p class="cz-muted">Your bag is empty.</p>';
    return;
  }
  cartItems.innerHTML=cart.items.map((item,i)=>`
    <div class="cz-cart-line">
      <a href="${item.url}">${item.image?`<img src="${item.image}" alt="">`:''}</a>
      <div><h4><a href="${item.url}">${item.product_title}</a></h4><small>${item.variant_title || ''} · Qty ${item.quantity}</small></div>
      <div class="cz-cart-line__price"><strong>${money(item.final_line_price)}</strong><br><button class="cz-cart-line__remove" data-remove-line="${i+1}">Remove</button></div>
    </div>`).join('');
  qsa('[data-remove-line]',cartItems).forEach(btn=>btn.addEventListener('click',async()=>{
    await fetch(window.Shopify.routes.root+'cart/change.js',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:Number(btn.dataset.removeLine),quantity:0})
    });
    await renderCart();
  }));
}

qsa('[data-add-to-cart]').forEach(btn=>btn.addEventListener('click',async()=>{
  const original=btn.textContent;
  btn.disabled=true; btn.textContent='ADDING…';
  try{
    const r=await fetch(window.Shopify.routes.root+'cart/add.js',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:Number(btn.dataset.variantId),quantity:1}]})
    });
    if(!r.ok) throw new Error('Could not add item');
    await renderCart(); openCart(); btn.textContent='ADDED ✓';
  }catch(e){
    btn.textContent='TRY AGAIN';
  }finally{
    setTimeout(()=>{btn.disabled=false;btn.textContent=original;},1200);
  }
}));

const productForm=qs('.cz-product-form');
if(productForm){
  productForm.addEventListener('submit',async e=>{
    e.preventDefault();
    const fd=new FormData(productForm);
    const id=Number(fd.get('id')),quantity=Number(fd.get('quantity')||1);
    const submit=productForm.querySelector('[type=submit]');
    const original=submit.textContent;
    submit.disabled=true;submit.textContent='ADDING…';
    try{
      const r=await fetch(window.Shopify.routes.root+'cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id,quantity}]})
      });
      if(!r.ok) throw new Error();
      await renderCart();openCart();submit.textContent='ADDED ✓';
    }catch(e){submit.textContent='TRY AGAIN';}
    finally{setTimeout(()=>{submit.disabled=false;submit.textContent=original;},1200);}
  });
}


// CULTZAAR responsive mobile menu
const mobileMenu=qs('[data-mobile-menu]');
function openMenu(){
  mobileMenu?.classList.add('is-open');
  mobileMenu?.setAttribute('aria-hidden','false');
  document.documentElement.style.overflow='hidden';
}
function closeMenu(){
  mobileMenu?.classList.remove('is-open');
  mobileMenu?.setAttribute('aria-hidden','true');
  document.documentElement.style.overflow='';
}
qsa('[data-menu-open]').forEach(b=>b.addEventListener('click',openMenu));
qsa('[data-menu-close]').forEach(b=>b.addEventListener('click',closeMenu));
qsa('[data-menu-link]').forEach(a=>a.addEventListener('click',closeMenu));
window.addEventListener('resize',()=>{if(window.innerWidth>1024) closeMenu();});


// CULTZAAR v2 collection sorting
qsa('[data-sort-select]').forEach(select=>{
  select.addEventListener('change',()=>{
    const url=new URL(window.location.href);
    url.searchParams.set('sort_by',select.value);
    window.location.href=url.toString();
  });
});

// collapsible filters
qsa('[data-filter-toggle]').forEach(btn=>{
  btn.addEventListener('click',()=>{
    const block=btn.closest('.cz-filter-block');
    block?.classList.toggle('is-collapsed');
    const icon=btn.querySelector('span:last-child');
    if(icon) icon.textContent=block?.classList.contains('is-collapsed')?'＋':'−';
  });
});

// mobile filters
const filterPanel=qs('[data-filter-panel]');
const filterOverlay=qs('[data-filter-overlay]');
function openFilters(){
  filterPanel?.classList.add('is-open');
  filterOverlay?.classList.add('is-visible');
  document.documentElement.style.overflow='hidden';
}
function closeFilters(){
  filterPanel?.classList.remove('is-open');
  filterOverlay?.classList.remove('is-visible');
  document.documentElement.style.overflow='';
}
qsa('[data-filter-open]').forEach(b=>b.addEventListener('click',openFilters));
qsa('[data-filter-close]').forEach(b=>b.addEventListener('click',closeFilters));
filterOverlay?.addEventListener('click',closeFilters);

// PDP quantity controls
qsa('[data-qty-minus]').forEach(btn=>btn.addEventListener('click',()=>{
  const input=btn.parentElement.querySelector('[data-qty-input]');
  if(input) input.value=Math.max(1,Number(input.value||1)-1);
}));
qsa('[data-qty-plus]').forEach(btn=>btn.addEventListener('click',()=>{
  const input=btn.parentElement.querySelector('[data-qty-input]');
  if(input) input.value=Number(input.value||1)+1;
}));

// PDP custom option buttons -> Shopify master variant select
const pdpForm=qs('.cz-pdp-form');
if(pdpForm){
  const master=qs('[data-master-variant-select]',pdpForm);
  const radios=qsa('[data-option-position]',pdpForm);
  const submit=qs('[data-product-submit]',pdpForm);

  function syncVariant(){
    if(!master) return;
    const selected={};
    radios.filter(r=>r.checked).forEach(r=>selected[Number(r.dataset.optionPosition)]=r.value);

    const match=[...master.options].find(o=>{
      const checks=[
        !selected[1] || o.dataset.option1===selected[1],
        !selected[2] || o.dataset.option2===selected[2],
        !selected[3] || o.dataset.option3===selected[3]
      ];
      return checks.every(Boolean);
    });

    if(!match) return;
    master.value=match.value;
    const available=match.dataset.available==='true';
    if(submit){
      submit.disabled=!available;
      submit.textContent=available?'ADD TO BAG':'SOLD OUT';
    }

    const priceEl=qs('[data-product-price]');
    if(priceEl) priceEl.textContent=money(Number(match.dataset.price||0));
    const compareEl=qs('[data-product-compare-price]');
    if(compareEl){
      const c=Number(match.dataset.compare||0);
      compareEl.textContent=c?money(c):'';
      compareEl.style.display=c?'inline':'none';
    }
  }
  radios.forEach(r=>r.addEventListener('change',syncVariant));
}

// CULTZAAR v2.1 day/night toggle
(function(){
  const root=document.documentElement;
  const buttons=[...document.querySelectorAll('[data-theme-toggle]')];
  const labels=[...document.querySelectorAll('[data-theme-label]')];
  const current=()=>root.getAttribute('data-theme')==='light'?'light':'dark';
  function sync(){
    const t=current();
    buttons.forEach(b=>{
      b.setAttribute('aria-pressed',t==='light'?'true':'false');
      b.setAttribute('aria-label',t==='light'?'Switch to night mode':'Switch to day mode');
    });
    labels.forEach(l=>l.textContent=t==='light'?'NIGHT':'DAY');
  }
  function setTheme(t){
    root.setAttribute('data-theme',t);
    try{localStorage.setItem('cultzaar-theme',t)}catch(e){}
    sync();
  }
  buttons.forEach(b=>b.addEventListener('click',()=>setTheme(current()==='dark'?'light':'dark')));
  sync();
})();


// CULTZAAR v2.4 language switcher
qsa('[data-language-select]').forEach(select=>{
  select.addEventListener('change',()=>{
    if(select.form) select.form.submit();
  });
});

// CULTZAAR v2.4 trusted email guard for storefront forms.
// Note: Shopify-hosted Customer Accounts and checkout need a server/app rule
// for hard disposable-email blocking.
(function(){
  const body=document.body;
  const enabled=body?.dataset.emailGuardEnabled==='true';
  if(!enabled) return;

  const raw=(body.dataset.emailAllowedDomains||'').toLowerCase();
  const allowed=raw.split(',').map(x=>x.trim()).filter(Boolean);

  const disposableHints=[
    'tempmail','10minutemail','guerrillamail','mailinator','yopmail',
    'sharklasers','throwaway','trashmail','getnada','dispostable',
    'fakeinbox','temp-mail','mohmal'
  ];

  function allowedEmail(email){
    const clean=(email||'').trim().toLowerCase();
    const at=clean.lastIndexOf('@');
    if(at<1) return false;
    const domain=clean.slice(at+1);
    if(disposableHints.some(x=>domain.includes(x))) return false;
    if(!allowed.length) return true;
    return allowed.includes(domain);
  }

  qsa('[data-email-guard-form]').forEach(form=>{
    form.addEventListener('submit',ev=>{
      const input=qs('[data-email-guard-input]',form);
      const error=qs('[data-email-guard-error]',form);
      if(!input) return;
      const ok=allowedEmail(input.value);
      if(!ok){
        ev.preventDefault();
        if(error) error.hidden=false;
        input.setAttribute('aria-invalid','true');
        input.focus();
      }else{
        if(error) error.hidden=true;
        input.removeAttribute('aria-invalid');
      }
    });
  });
})();


// CULTZAAR v2.6 — easy text-size control
(function(){
  const root=document.documentElement;
  const buttons=[...document.querySelectorAll('[data-font-size]')];
  const allowed=['small','normal','large'];

  function apply(size){
    const next=allowed.includes(size)?size:'normal';
    root.setAttribute('data-font-size',next);
    try{localStorage.setItem('cultzaar-font-size',next)}catch(e){}
    buttons.forEach(btn=>{
      const active=btn.dataset.fontSize===next;
      btn.classList.toggle('is-active',active);
      btn.setAttribute('aria-pressed',active?'true':'false');
    });
  }

  let saved='normal';
  try{saved=localStorage.getItem('cultzaar-font-size')||'normal'}catch(e){}
  apply(saved);
  buttons.forEach(btn=>btn.addEventListener('click',()=>apply(btn.dataset.fontSize)));
})();
